import { ReactElement } from 'react';

import '../styles/components/LoggerCheckTable.less';

interface Props {
    scanType: string | undefined;
    hideActions?: boolean;
}

const LoggerCheckTableHeaderRow = ({ scanType, hideActions }: Props): ReactElement => (
    <div data-testid="header-row" className="header-row">
        <div className="col-0">{hideActions && '#'}</div>

        <div className="col-1">
            <div>Logger ID</div>
            <div className="customer">Customer</div>
        </div>
        {scanType !== 'MANUFACTURER-BOX' && <div className="col-2">Valid Logger</div>}

        {scanType !== 'MANUFACTURER-BOX' && <div className={`col-3 ${scanType}`}>Calibration</div>}
        {scanType !== 'MANUFACTURER-BOX' && <div className={`col-4 ${scanType}`}>Tests</div>}
        <div className={`col-5 ${scanType}`}>Flags</div>
        <div className={`col-6 ${scanType}`}>Temperature</div>
        <div className={`col-7 ${scanType != 'QA-CHECK' ? scanType : ''}`}>Battery</div>
        <div className={`col-8 ${scanType}`}>Firmware</div>
        {scanType !== 'MANUFACTURER-BOX' && <div className={`col-9 ${scanType}`}>Sensors</div>}
        {scanType !== 'MANUFACTURER-BOX' && <div className={`col-10 ${scanType}`}>Shipment</div>}
        {!hideActions && <div className="col-11">Actions</div>}
    </div>
);

export default LoggerCheckTableHeaderRow;
